import $ from 'jquery'
import * as components from './components'

window.$ = $
window.jQuery = $

const setupPages = (function() {
  // console.log('SetupPages')
  components.siteUI()
})()

const mainInit = (function() {
  setupPages
})()

function Main() {
  this.init = function() {
    $(document).ready(mainInit)
  }
  return {
    init: this.init
  }
}

const main = new Main()
main.init()



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/app.js